import React, { useEffect, useState } from "react";

import { getClientClaimById } from "../../api/ClientClaimApi";
import { toast } from "../shared/Toast";

const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    } catch (e) {
        return dateStr;
    }
};

const ViewClientClaimModal = ({
    id,
    close
}) => {

    const [loading, setLoading] = useState(true);

    const [claim, setClaim] = useState(null);

    const fetchClaim = async () => {

        try {

            const response = await getClientClaimById(id);

            setClaim(response.data || response);

        }

        catch (error) {

            console.log(error);

            setClaim(null);

            toast.error("Unable to load Client Claim");

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchClaim();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
            }}
        >

            <div
                style={{
                    width: 600,
                    background: "#fff",
                    borderRadius: 10,
                    padding: 30
                }}
            >

                <h2
                    style={{
                        marginBottom: 20
                    }}
                >
                    Client Claim Details
                </h2>

                {

                    loading ?

                        <p>Loading...</p>

                        :

                        <>

                            <Row
                                label="Client"
                                value={claim.client?.clientName}
                            />

                            <Row
                                label="From Date"
                                value={formatDate(claim.fromDate)}
                            />

                            <Row
                                label="To Date"
                                value={formatDate(claim.toDate)}
                            />

                            <Row
                                label="Total Trips"
                                value={claim.totalTrips}
                            />

                            <Row
                                label="Total Amount"
                                value={`₹ ${claim.totalAmount}`}
                            />

                            <Row
                                label="Deduction"
                                value={`₹ ${claim.deduction}`}
                            />

                            <Row
                                label="Final Claim"
                                value={`₹ ${claim.finalClaimAmount}`}
                            />

                            <Row
                                label="Status"
                                value={claim.status}
                            />

                            <Row
                                label="Remarks"
                                value={
                                    claim.remarks || "-"
                                }
                            />

                        </>

                }

                <div
                    style={{
                        marginTop: 30,
                        display: "flex",
                        justifyContent: "flex-end"
                    }}
                >

                    <button

                        onClick={close}

                        style={{
                            background: "#20B967",
                            color: "#fff",
                            border: "none",
                            padding: "10px 30px",
                            borderRadius: 6,
                            cursor: "pointer"
                        }}

                    >

                        Close

                    </button>

                </div>

            </div>

        </div>

    );

};

const Row = ({
    label,
    value
}) => (

    <div
        style={{
            display: "flex",
            marginBottom: 15
        }}
    >

        <div
            style={{
                width: 180,
                fontWeight: 600
            }}
        >

            {label}

        </div>

        <div>

            {value}

        </div>

    </div>

);

export default ViewClientClaimModal;